import { lazy, ReactElement } from 'react';
import { createHashRouter, createRoutesFromElements, Navigate, Route } from 'react-router-dom';

import AuthenticatedRoute from './components/auth/AuthenticatedRoute';
import RoleProtectedRoute from './components/auth/RoleProtectedRoute';
import { createMsalInstance, ssoSilent } from './features';
import LocationDetails from './pages/locations/LocationDetails';
import Locations from './pages/locations/Locations';
import { getAppSettings } from './services';

const Login = lazy(() => import('./pages/login/Login'));

const Reports = lazy(() => import('./pages/reports/Reports'));

const createAppRouter = (appElement: ReactElement) => {
  return createHashRouter(
    createRoutesFromElements(
      <Route
        element={appElement}
        handle={{
          crumb: () => 'k-i-home',
        }}
        loader={async ({ params }) =>
          getAppSettings()
            .then((settings) => createMsalInstance(settings))
            .then((msalInstance) => ssoSilent(msalInstance))
        }
      >
        <Route element={<AuthenticatedRoute requireAuth={false} redirectPath='/' />}>
          <Route path='/login' element={<Login />} />
          <Route path='*' element={<Navigate to='/login' replace />} />
        </Route>
        <Route element={<AuthenticatedRoute requireAuth={true} redirectPath='/login' />}>
          <Route element={<RoleProtectedRoute allowedRoles={['AppAdmin', 'ReportViewer']} />}>
            {/* the reports are opened for the customer of the path: /{customerId}/{report}/{page} */}
            <Route index element={<Reports />} />
            <Route path=':routeCustomerId' element={<Reports />} />
            <Route path=':routeCustomerId/:routeReportType' element={<Reports />} />
            <Route path=':routeCustomerId/:routeReportType/:routeReportPage' element={<Reports />} />
          </Route>
          <Route element={<RoleProtectedRoute allowedRoles={['AppAdmin', 'LocationViewer']} />}>
            <Route path='/locations' element={<Locations />} />
            <Route path='/locations/:locationId' element={<LocationDetails />} />
          </Route>
          <Route path='*' element={<Navigate to='/' replace />} />
        </Route>
      </Route>,
    ),
  );
};

export default createAppRouter;
